module.exports = __webpack_public_path__ + "media/images/alert-6a40573b19121aea23da2bd7ed3f236a.svg";